import { DeliveryHeadStatus } from "../Enums";
import IItemWithSignatureRaw from "../IItemWithSignatureRaw";
import IAudit from "../responses/IAudit";
import Item from "./Item";
import Site from "./Site";

export class DeliveryLine implements IItemWithSignatureRaw {
  constructor(
    public item: Item,
    public lot: string | undefined,
    public bestBefore: string | undefined,
    public expiry: string | undefined,
    public quantity: number,
  ) { }
}

export default class Delivery {
  constructor(
    public id: number,
    public site: Site,
    public code: string,
    public description: string,
    public status: DeliveryHeadStatus,
    public lines: DeliveryLine[],
    public audit: IAudit,
  ) { }
}